import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  makeCall,
} from "../../../../utils/service";


export async function getDeveloper() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLDEVELOPER,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateProjectDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATELEADDEFORMTAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

/** CRM projects for a developer (includes inactive website listings). */
export async function getProjectsByDeveloper(developerId: string) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      developerId: String(developerId || ""),
      portalsOnly: "0",
      limit: "2000",
      page: "0",
    });
    return await makeCall(
      `${urls.GETALLPROJECT}?${qs.toString()}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}

/** Search CRM projects by name or project uid (PC_xxxx). */
export async function searchProjects(search: string, developerId?: string) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      search: String(search || "").trim(),
      portalsOnly: "0",
      limit: "50",
      page: "0",
    });
    if (developerId) qs.set("developerId", String(developerId));
    return await makeCall(
      `${urls.GETALLPROJECT}?${qs.toString()}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}

/** Unit / price list from project_details (no status filter). */
export async function getProjectUnitOptions(projectId: string) {
  try {
    const callParams = await getCallParams("GET");
    const qs = new URLSearchParams({
      projectId: String(projectId || ""),
      limit: "5",
      page: "0",
    });
    const response = await makeCall(
      `${urls.GETPROJECTLIST}?${qs.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

/** @deprecated Prefer getProjectsByDeveloper — kept for callers that need details priceList */
export async function getProjectDetails(developerId?: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETPROJECTLIST}?developerId=${developerId}&status=1`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}


export async function listWebsiteForms(organizationId: string) {
  try {
    const callParams = await getCallParams("GET");
    const params = new URLSearchParams({
      formType: "website",
      limit: "20",
      page: "0",
    });
    if (organizationId) params.set("organizationId", organizationId);
    const response = await makeCall(
      `${urls.GETALLLEADS}?${params.toString()}`,
      callParams
    );
    return Array.isArray(response?.data) ? response.data : [];
  } catch (error) {
    throw error;
  }
}

export async function addForm(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDFORM, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getFormById(id: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(`${urls.GETFORMBYID}${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function listFeedbackForms() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.url_prod}/feedback/forms`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function mintFeedbackLink(body: {
  formId: string;
  leadId?: string;
}) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(
      `${urls.url_prod}/feedback/mint-link`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getGoogleSheetStatus() {
  try {
    const callParams = await getCallParams("GET");
    return await makeCall(`${urls.url_prod}/google-sheet/status`, callParams);
  } catch (error) {
    throw error;
  }
}

export async function getGoogleSheetAuthUrl(returnTo?: string) {
  try {
    const callParams = await getCallParams("GET");
    const qs = returnTo
      ? `?returnTo=${encodeURIComponent(returnTo)}`
      : "";
    return await makeCall(
      `${urls.url_prod}/google-sheet/auth-url${qs}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}

export async function disconnectGoogleSheet() {
  try {
    const callParams = await getCallParams("POST", {});
    return await makeCall(
      `${urls.url_prod}/google-sheet/disconnect`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}

export async function listGoogleSpreadsheets() {
  try {
    const callParams = await getCallParams("GET");
    return await makeCall(
      `${urls.url_prod}/google-sheet/spreadsheets`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}

export async function listGoogleSheetTabs(spreadsheetId: string) {
  try {
    const callParams = await getCallParams("GET");
    const qs = `?spreadsheetId=${encodeURIComponent(spreadsheetId)}`;
    return await makeCall(
      `${urls.url_prod}/google-sheet/tabs${qs}`,
      callParams
    );
  } catch (error) {
    throw error;
  }
}

export async function createGoogleSpreadsheet(title?: string) {
  try {
    const callParams = await getCallParams("POST", { title: title || "" });
    return await makeCall(`${urls.url_prod}/google-sheet/create`, callParams);
  } catch (error) {
    throw error;
  }
}

export async function testGoogleSheetConnection(body: {
  spreadsheetId: string;
  sheetName?: string;
}) {
  try {
    const callParams = await getCallParams("POST", body);
    return await makeCall(`${urls.url_prod}/google-sheet/test`, callParams);
  } catch (error) {
    throw error;
  }
}
